import { Inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { take, mergeMap, of, shareReplay } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TranslationsLoadedService {

    constructor(@Inject(TranslocoService) private translocoService: TranslocoService) {
    }

    isLoaded = this.translocoService.events$.pipe(
        take(1),
        mergeMap(e => {
            return of(e.type === 'translationLoadSuccess')
        }),
        shareReplay(1)
    );
}
